import { PermissionRole } from '@fabric/woody-client';

const convertResourceRootToSpace = (resourceRoot) => {
  const integration = "integration" in resourceRoot ? resourceRoot.integration : null;
  return {
    id: resourceRoot.folder.id,
    type: resourceRoot.type,
    title: resourceRoot.folder.name || "New space",
    role: resourceRoot.folder.permissions?.role || PermissionRole.VIEWER,
    integration: integration?.id || null,
    slug: void 0,
    isPublic: resourceRoot.folder.isPublic,
    createdAt: resourceRoot.createdAt,
    modifiedAt: resourceRoot.modifiedAt,
    externalId: integration?.externalId || null,
    owner: void 0,
    labels: void 0,
    _meta: {
      isDeleting: false,
      isUpdating: false
    }
  };
};

export { convertResourceRootToSpace };
//# sourceMappingURL=convertSpaceRootToSpace.js.map
